var map = {
	"./anchor.png": 24253,
	"./ar.png": 6455,
	"./brands/gfmarkets/logo-mobile.png": 20702,
	"./brands/utocapital/logo-mobile.png": 29670,
	"./brands/utocapital/logo.png": 61549,
	"./brands/wintrado/logo-mobile.png": 87070,
	"./buy_small.png": 52720,
	"./commodity.png": 10067,
	"./currency.png": 34947,
	"./de.png": 33515,
	"./en.png": 11983,
	"./es.png": 47610,
	"./exchange_logo.png": 73371,
	"./fr.png": 15214,
	"./generic-android-install-instructions.png": 70573,
	"./hi.png": 38787,
	"./hot.png": 67413,
	"./indices.png": 99355,
	"./instruments/100GBP.png": 19529,
	"./instruments/225JPY.png": 13979,
	"./instruments/AAPL.png": 83373,
	"./instruments/AAVEUSD.png": 95104,
	"./instruments/ADA.png": 15087,
	"./instruments/ADAUSD.png": 81791,
	"./instruments/AEX25.png": 10818,
	"./instruments/AMZN.png": 59653,
	"./instruments/AUDCAD.png": 92185,
	"./instruments/AUDCHF.png": 49788,
	"./instruments/AUDJPY.png": 3050,
	"./instruments/AUDNZD.png": 86853,
	"./instruments/AUDUSD.png": 2285,
	"./instruments/AUS200.png": 2634,
	"./instruments/AVAX.png": 96505,
	"./instruments/AVAXUSD.png": 59545,
	"./instruments/BABA.png": 25983,
	"./instruments/BATUSD.png": 47724,
	"./instruments/BCH.png": 30204,
	"./instruments/BCHUSD.png": 16782,
	"./instruments/BNB.png": 52937,
	"./instruments/BNBUSD.png": 52841,
	"./instruments/BTC.png": 85014,
	"./instruments/BTCUSD.png": 88592,
	"./instruments/CAC40.png": 66828,
	"./instruments/CADCHF.png": 64554,
	"./instruments/CADJPY.png": 6844,
	"./instruments/CHFJPY.png": 90759,
	"./instruments/COCOA.png": 54398,
	"./instruments/COFFEE.png": 91463,
	"./instruments/COMPUSD.png": 92424,
	"./instruments/COPPER.png": 6228,
	"./instruments/COUS.png": 49149,
	"./instruments/CRVUSD.png": 94198,
	"./instruments/D40EUR.png": 4271,
	"./instruments/DASH.png": 25079,
	"./instruments/DASHUSD.png": 13015,
	"./instruments/DAX30.png": 86761,
	"./instruments/DJ30.png": 32912,
	"./instruments/DOGEUSD.png": 85902,
	"./instruments/DOTUSD.png": 86264,
	"./instruments/E50EUR.png": 56873,
	"./instruments/EBAY.png": 68296,
	"./instruments/ENJUSD.png": 27772,
	"./instruments/EOSUSD.png": 36890,
	"./instruments/ESP35.png": 95315,
	"./instruments/ESX50.png": 5472,
	"./instruments/ETH.png": 94730,
	"./instruments/ETHUSD.png": 37244,
	"./instruments/EU50.png": 79282,
	"./instruments/EURAUD.png": 31721,
	"./instruments/EURCAD.png": 28371,
	"./instruments/EURCHF.png": 71522,
	"./instruments/EURGBP.png": 19762,
	"./instruments/EURJPY.png": 38276,
	"./instruments/EURMXN.png": 52100,
	"./instruments/EURNOK.png": 49627,
	"./instruments/EURNZD.png": 59675,
	"./instruments/EURSEK.png": 21752,
	"./instruments/EURTRY.png": 42628,
	"./instruments/EURUSD.png": 54207,
	"./instruments/Europe50.png": 46977,
	"./instruments/FB.png": 13835,
	"./instruments/FTSE 100.png": 40772,
	"./instruments/FTTUSD.png": 57797,
	"./instruments/GBPAUD.png": 11594,
	"./instruments/GBPCAD.png": 78016,
	"./instruments/GBPCHF.png": 81361,
	"./instruments/GBPJPY.png": 98663,
	"./instruments/GBPNZD.png": 13092,
	"./instruments/GBPTRY.png": 8707,
	"./instruments/GBPUSD.png": 76976,
	"./instruments/GLMR.png": 74139,
	"./instruments/GLMRUSD.png": 78515,
	"./instruments/GOLD.png": 49889,
	"./instruments/GOOG.png": 87743,
	"./instruments/H33HKD.png": 60908,
	"./instruments/HK50.png": 8567,
	"./instruments/IOTUSD.png": 79339,
	"./instruments/JP225.png": 81872,
	"./instruments/JPN225.png": 45630,
	"./instruments/KESUSD.png": 81630,
	"./instruments/KO.png": 24813,
	"./instruments/KSM.png": 83472,
	"./instruments/KSMUSD.png": 89146,
	"./instruments/LINKUSD.png": 24651,
	"./instruments/LRCUSD.png": 13068,
	"./instruments/LTC.png": 90192,
	"./instruments/LTCUSD.png": 77050,
	"./instruments/LUNA.png": 15957,
	"./instruments/LUNAUSD.png": 47501,
	"./instruments/MANAUSD.png": 88976,
	"./instruments/MATIC.png": 42089,
	"./instruments/MATICUSD.png": 64553,
	"./instruments/MKRUSD.png": 74805,
	"./instruments/MSFT.png": 22353,
	"./instruments/NAS100.png": 61812,
	"./instruments/NASDAQ100.png": 86062,
	"./instruments/NASUSD.png": 28577,
	"./instruments/NEOUSD.png": 66769,
	"./instruments/NFLX.png": 28475,
	"./instruments/NKE.png": 97029,
	"./instruments/NZDCAD.png": 23371,
	"./instruments/NZDCHF.png": 81290,
	"./instruments/NZDJPY.png": 56764,
	"./instruments/NZDUSD.png": 48695,
	"./instruments/OIL SPOT.png": 59883,
	"./instruments/OMGUSD.png": 60806,
	"./instruments/PALLADIUM.png": 91750,
	"./instruments/PLATINUM.png": 46323,
	"./instruments/PMGUSD.png": 31491,
	"./instruments/QTMUSD.png": 46043,
	"./instruments/SANDUSD.png": 661,
	"./instruments/SILVER.png": 58248,
	"./instruments/SMI20.png": 76788,
	"./instruments/SOL.png": 91933,
	"./instruments/SOLUSD.png": 81797,
	"./instruments/SOYBEAN.png": 35658,
	"./instruments/SUGAR.png": 72337,
	"./instruments/SUSHIUSD.png": 57933,
	"./instruments/TRXUSD.png": 91425,
	"./instruments/TSLA.png": 92129,
	"./instruments/U30USD.png": 58111,
	"./instruments/UK100.png": 40150,
	"./instruments/UKOIL.png": 47687,
	"./instruments/UNIUSD.png": 40545,
	"./instruments/US30.png": 58382,
	"./instruments/US500.png": 48458,
	"./instruments/USDAUD.png": 32941,
	"./instruments/USDCAD.png": 17807,
	"./instruments/USDCHF.png": 702,
	"./instruments/USDHKD.png": 65846,
	"./instruments/USDINR.png": 42598,
	"./instruments/USDJPY.png": 14712,
	"./instruments/USDMXN.png": 31736,
	"./instruments/USDNOK.png": 16287,
	"./instruments/USDSEK.png": 14676,
	"./instruments/USDSGD.png": 58149,
	"./instruments/USDTRY.png": 21456,
	"./instruments/USDZAR.png": 42892,
	"./instruments/USOIL.png": 83663,
	"./instruments/USOUSD.png": 51010,
	"./instruments/WS30.png": 25536,
	"./instruments/XAGUSD.png": 38295,
	"./instruments/XAUUSD.png": 60397,
	"./instruments/XLMUSD.png": 72964,
	"./instruments/XMR.png": 95566,
	"./instruments/XMRUSD.png": 20248,
	"./instruments/XRP.png": 90653,
	"./instruments/XRPUSD.png": 4133,
	"./instruments/XTZUSD.png": 8205,
	"./instruments/ZEC.png": 89633,
	"./instruments/ZECUSD.png": 75121,
	"./instruments/ZM.png": 24192,
	"./instruments/unsupported.png": 8086,
	"./it.png": 40713,
	"./ja.png": 80897,
	"./km.png": 48662,
	"./login/logo-decoration.png": 30114,
	"./my.png": 18904,
	"./no_active_competitions.png": 55439,
	"./person.png": 10473,
	"./pt.png": 85678,
	"./rotate-device.png": 34132,
	"./ru.png": 94909,
	"./sell_small.png": 90158,
	"./special/mpesa.png": 9472,
	"./sw.png": 70820,
	"./tr.png": 24116,
	"./ur.png": 79795,
	"./vi.png": 69949,
	"./zh.png": 33760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65336;